<div class="app-header d-flex justify-content-center align-items-center text-center text-white">
  <div class="content">
    <h6 class="fw-normal mb-1 subtitle">{{ subtitle() }}</h6>
    <h1 class="fw-bold mb-2 title">{{ title() }}</h1>
    <div class="divider mx-auto"></div>
  </div>
</div>